import React from 'react';
import { Dumbbell, Info } from 'lucide-react';

interface PlannedWorkoutStateProps {
    template: any;
}

export const PlannedWorkoutState: React.FC<PlannedWorkoutStateProps> = ({ template }) => (
    <div style={{ paddingBottom: '20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '20px', borderBottom: '1px solid #111', paddingBottom: '10px' }}>
            <Dumbbell size={14} color="#f29b11" />
            <span style={{ fontSize: '10px', fontWeight: '900', color: '#fff', letterSpacing: '2px' }}>MISSION TEMPLATE</span>
        </div>
        
        {!template ? (
            <div style={{ padding: '20px', textAlign: 'center', color: '#444' }}>
                <Info size={24} style={{ margin: '0 auto 10px' }} />
                <p style={{ fontSize: '11px' }}>Select a program and training day above to see the targets.</p>
            </div>
        ) : (
            (template.blocks as any[])?.map(block => (
                <div key={block.id} style={{ marginBottom: '25px' }}>
                    <div style={{ fontSize: '9px', fontWeight: '900', color: '#f29b11', textTransform: 'uppercase', marginBottom: '10px', borderLeft: '2px solid #f29b11', paddingLeft: '8px' }}>{block.label}</div>
                    {(block.block_items as any[])?.map(item => (
                        <div key={item.id} style={{ marginBottom: '15px', paddingLeft: '10px' }}>
                            <div style={{ fontSize: '13px', fontWeight: '700', color: '#fff' }}>{item.exercise_library?.name}</div>
                            <div style={{ fontSize: '10px', color: 'rgba(242, 155, 17, 0.7)', fontWeight: '800', fontFamily: 'monospace' }}>
                                {item.target_sets} × {item.target_reps} R @ {item.target_weight}kg
                            </div>
                        </div>
                    ))}
                </div>
            ))
        )}
    </div>
);
